<template>
  <div class="page-403">
    <ErrorPage :code="''" desc="抱歉，该页面暂时没有权限，请联系系统管理员">
      <img slot="img" src="../assets/image/403.svg" alt="" />
    </ErrorPage>
  </div>
</template>
<script>
import ErrorPage from 'components/error/errorPage';
export default {
  components: {
    ErrorPage
  }
};
</script>
